<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          class="header-item"
          style="width: 100%"
          placeholder="策略"
          v-model="celv"
          clearable
          filterable
          @change="celvChange"
        >
          <el-option
            v-for="(item,index) in celvOptions"
            :key="index"
            :label="item.strategyName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          placeholder="请选择推送渠道"
          v-model="pushChannel"
          style="width: 100%"
          class=""
          clearable
          @clear="clearHandle"
          filterable
          @change="pushChannelChange"
        >
          <el-option
            v-for="(item,index) in pushChannelOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          class="header-item"
          style="width: 100%"
          placeholder="推送配置"
          v-model="pushConfig"
          filterable
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in pushConfigOptions"
            :key="index"
            :label="getLabel(item)"
            :value="getValue(item)"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-input
          v-model="ruleName"
          placeholder="规则名称"
          style="width: 100%;"
          clearable
        ></el-input>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          class="header-item"
          style="width: 100%"
          placeholder="状态"
          v-model="status"
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in statusOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-date-picker
          v-if="!realMobile"
          style="width: 100%;"
          v-model="pickerTime"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="toQuery"
        >
        </el-date-picker>
        <select-date-duration
          class="header-item"
          v-model="pickerTime"
        ></select-date-duration>
      </el-col>
      <el-col
        class="btn-outer"
      >
        <vs-button
          type="info"
          style="margin-right: 10px"
          class="search-btn btn box-item"
          @click="searchHandle"
        >查询</vs-button>
        <!--
        v-if="isAuth('sys:role:save')"
        -->
        <vs-button
          style="margin-right: 10px"
          v-if="isAuth('wx:spiderArticlePublish:save')"
          class="add-btn btn box-item"
          @click="addHandle"
        >新增</vs-button>
        <!--
        v-if="isAuth('sys:role:delete')"
        -->

        <vs-button
          v-if="isAuth('wx:spiderArticlePublish:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn box-item"
          @click="deleteHandle"
        >批量删除</vs-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryPushTab } from '@/api/user'
import { mapGetters } from 'vuex'
import { handlerChannelConfig } from "../../../utils";
import { getQqConfigList } from '@/api/sys/robitConfig/qq'
export default {
  name: "queryHeader",
  props: {
    selected: {
      type: Array,
      default(){
        return [];
      }
    },
  },
  data() {
    return {
      celv: [],
      celvOptions: [],
      pushChannel: '',
      pushChannelOptions: [
        /*{label: '微信公众号',value: 1},
        {label: 'Telegram',value: 2},
        {label: 'Lark应用',value: 3},
        {label: '企业微信',value: 4},
        {label: '个人微信',value: 5},
        {label: 'Lark机器人',value: 6},
        {label: '钉钉',value: 7},
        {label: 'MT4',value: 8},*/
      ],
      pushConfig: '',
      pushConfigOptions: [],
      ruleName: '',
      status: '',
      statusOptions:[
        { label: '启用',value: 1 },
        { label: '禁用',value: 0 },
      ],
      pickerTime: [],
    }
  },
  computed: {
    ...mapGetters(['realMobile']),
  },
  created(){
    this.getCelvList();
    this.getPushChannel();
  },
  methods: {
    getPushChannel(){
      queryPushTab().then((res) => {
        console.log(res);
        // 1-微信公众号 2-telegram 3-Lark应用 4-企业微信 5-个人微信 6-Lark机器人 7-钉钉机器人 8-MT4
        /*for (let i = 0; i < res.channelTypes.length; i++) {
          switch (res.channelTypes[i]){
            case 1:
              this.pushChannelOptions.push({label: '微信公众号',value: 1});
              break;
            case 2:
              this.pushChannelOptions.push({label: 'Telegram',value: 2});
              break;
            case 3:
              this.pushChannelOptions.push({label: 'Lark应用',value: 3});
              break;
            case 4:
              this.pushChannelOptions.push({label: '企业微信',value: 4});
              break;
            case 5:
              this.pushChannelOptions.push({label: '个人微信',value: 5});
              break;
            case 6:
              this.pushChannelOptions.push({label: 'Lark机器人',value: 6});
              break;
            case 7:
              this.pushChannelOptions.push({label: '钉钉',value: 7});
              break;
            case 8:
              this.pushChannelOptions.push({label: 'MT4',value: 8});
              break;
          }
        }*/
        handlerChannelConfig(res.channelTypes,this.pushChannelOptions);
      })
    },
    getCelvList(){
      this.$http({
        url: '/wx/manage/forwardStrategy/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 1000,
          'sidx': 'id',
          'order': 'desc'
        }
      }).then((data) => {
        if (data.code === 200) {
          this.celvOptions = data.page.list
        } else {
          this.celvOptions = [];
        }
        this.$emit('strategy-options', this.celvOptions);
      })
    },
    pushChannelChange(val){
      this.pushConfig = '';
      this.pushConfigOptions = [];
      this.getPushRuleList(val);
      this.toQuery();
    },
    setPushConfigOptions(channelType, data){
      if(this.pushChannel !== channelType) return;
      this.pushConfigOptions = data && data.code === 200 ? data.page.list : [];
    },
    getPushRuleList(channelType){
      switch (channelType){
        case 1:
          this.getWeChatOfficial();
          break;
        case 2:
          this.getTelegram();
          break;
        case 3:
          this.getLarkApp();
          break;
        case 4:
          this.getCompanyWechat();
          break;
        case 5:
          this.getPersonalWechat();
          break;
        case 6:
          this.getFeishu();
          break;
        case 7:
          this.getDingding();
          break;
        case 8:
          this.getMt4Notice();
          break;
        case 9:
          this.getLines();
          break;
        case 10:
          this.getQq();
          break;
      }
    },
    //微信公众号
    getWeChatOfficial(){
      this.$http({
        url: '/wx/manage/msgTemplate/listWithoutCookie',
        method: 'get',
      }).then((data) => {
        console.log(data);
        console.log(data.page.list);
        this.setPushConfigOptions(1, data);
      })
    },
    // Telegram
    getTelegram(){
      this.$http({
        url: '/wx/manage/tgBotConfig/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 500,
          'sidx': 'id',
          'order': 'desc'
        }
      }).then((data) => {
        console.log(data);
        if(data && data.code === 200 && data.page){
          // 仅展示具备推送能力的 bot（botRole=2 推送 / 3 两者）
          data.page.list = (data.page.list || []).filter(
            item => item.botRole === 2 || item.botRole === 3
          );
        }
        this.setPushConfigOptions(2, data);
      })
    },
    // lark应用
    getLarkApp(){
      this.$http({
        url: '/wx/manage/larkAppConfig/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 500,
          'sidx': 'id',
          'sort': 'desc'
        }
      }).then((data) => {
        console.log(data);
        this.setPushConfigOptions(3, data);
      })
    },
    //企业微信
    getCompanyWechat(){
      this.$http({
        url: '/wx/manage/qywxBotConfig/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 500,
          'sidx': 'id',
          'sort': 'desc'
        }
      }).then((data) => {
        console.log(data);
        this.setPushConfigOptions(4, data);
      })
    },
    //个人微信
    getPersonalWechat(){
      this.$http({
        url: '/wx/manage/wxBotClientInfo/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 500,
          'sidx': 'id',
          'order':'desc',
        }
      }).then((data) => {
        console.log(data);
        this.setPushConfigOptions(5, data);
      })
    },
    // lark机器人
    getFeishu(){
      this.$http({
        url: '/wx/manage/larkBotConfig/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 500,
          'sidx': 'id',
          'sort': 'desc'
        }
      }).then((data) => {
        this.setPushConfigOptions(6, data);
      })
    },
    // 钉钉
    getDingding(){
      this.$http({
        url: '/wx/manage/dingtalkBot/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 500,
          'sidx': 'id',
          'sort': 'desc'
        }
      }).then((data) => {
        this.setPushConfigOptions(7, data);
      })
    },
    // mt4通知
    getMt4Notice(){
      this.$http({
        url: '/wx/manage/mt4Notifier/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 500,
          'sidx': 'id',
          'sort': 'desc'
        }
      }).then((data) => {
        this.setPushConfigOptions(8, data);
      })
    },
    getLines(){
      this.$http({
        url: '/wx/manage/lineChannel/list',
        method: 'get',
        params: {
          'page': 1,
          'limit': 500,
          'sidx': 'id',
          'sort': 'desc'
        }
      }).then((data) => {
        this.setPushConfigOptions(9, data);
      })
    },
    getQq(){
      getQqConfigList({
        page: 1,
        limit: 500,
        sidx: 'id',
        order: 'desc'
      }).then((data) => {
        this.setPushConfigOptions(10, data);
      })
    },
    getLabel(item){
      switch (this.pushChannel){
        case 1:
          return item.title + '-' + item.appName;
        case 2:
        case 4:
        case 6:
        case 7:
        case 8:
          return item.name;
        case 3:
          return item.appName;
        case 5:
          return item.botName;
        case 9:
          return item.channelName;
        case 10:
          return item.name;
      }
    },
    getValue(item){
      return item.id;
    },
    clearHandle(){
      this.pushConfigOptions = [];
      this.pushConfig = '';
    },
    toQuery(){
      this.$emit('toQuery');
    },
    celvChange(){
      this.$emit('toQuery');
    },
    searchHandle(){
      this.$emit('toQuery');
    },
    addHandle(){
      this.$emit('add');
    },
    deleteHandle(){
      this.$emit('delete');
    },
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .header-sub-item {
    width: 100%;
  }
  .btn-outer {
     margin-top: 10px;
    .box-item {
      margin-bottom: 10px;
    }
  }
}
</style>
